//frontend/src/components/BookingSteps.js
import React from 'react';
import { Box, Stepper, Step, StepLabel, Container } from '@mui/material';
import { useBooking } from '../context/BookingContext';
import { useTranslation } from 'react-i18next';

const BookingSteps = () => {
    const { t } = useTranslation();
    const { activeStep } = useBooking();
    
    const steps = [
        t('booking.steps.selectService'),
        t('booking.steps.selectSpecialist'),
        t('booking.steps.selectDateTime'),
        t('booking.steps.confirmation')
    ];

    return (
        <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
            <Box sx={{ width: '100%' }}>
                <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((label, index) => (
                        <Step key={label} completed={activeStep > index}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Box>
        </Container>
    );
};

export default BookingSteps;